
































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import delNonNumCode from '@/utils/delNonNumCode'

@Component
export default class AppTextField extends Vue {
  @Prop({ type: [Number, String] }) readonly value!: number | string
  @Prop(String) readonly label!: string
  @Prop({ type: String }) readonly placeholder!: string
  @Prop({ type: [Number, String], default: '310' }) readonly width!: number | string
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: String, default: 'text' }) readonly type!: string
  @Prop({ type: Boolean, default: false }) readonly autofocus!: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
  @Prop({ type: String, default: '' }) readonly className!: string
  @Prop({ type: Boolean, default: false }) readonly showSearch!: boolean
  @Prop({ type: Number, default: 100 }) readonly labelWidth!: number

  model = ''

  mounted () {
    if (this.type === 'phone') {
      this.model = this.convertPhoneType(this.value ? this.value + '' : '')
    } else if (this.type === 'number') {
      this.model = this.value ? this.value + '' : '0'
    } else {
      this.model = this.value ? this.value + '' : ''
    }
  }

  blurHandler () {
    const { model } = this
    if (this.type === 'phone') {
      this.valueChangedHandler(this.convertPhoneType(model))
    }
  }

  convertPhoneType (val: string) {
    const pureVal = delNonNumCode(val)
    if (pureVal.length > 6) {
      const state = pureVal.substring(0, 3)
      const first = pureVal.substring(3, 6)
      const last = pureVal.substring(6)
      return `(${state}) ${first}-${last}`
    } else if (pureVal.length > 3) {
      const state = pureVal.substring(0, 3)
      const first = pureVal.substring(3)
      return `(${state}) ${first}`
    } else {
      return pureVal
    }
  }

  keyDownHandler (e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.searchHandler()
    }
  }

  @Emit('search')
  searchHandler () {}

  @Emit('input')
  valueChangedHandler (val: string) {
    if (this.type === 'phone') {
      this.model = this.convertPhoneType(val)
    } else {
      this.model = val
    }
    return val
  }

  @Watch('value')
  onValueChanged (val: string) {
    if (this.type === 'phone') {
      this.model = this.convertPhoneType(val)
    } else {
      this.model = val
    }
  }
}
